import React from 'react';
import { Section, SectionTitle } from '../../../components/TwoColumnLayout';
import styled from 'styled-components';

interface Props {
	customerProcuraData: any[]
}

const Container = styled.div`
  padding-top: 1rem;
    input {
    width: 250px;
  }

  input[type="text"] {
    min-width: 450px;
  }

  .info{
    width: 200px;
    font-size: 1rem;
    padding-left: 1rem;
    // border: 1px solid red;
  }

  .grayInfo{
    font-size: 1rem;
    color: darkgray;
  }
`;

export const ProcuristInfo: React.FC<Props> = (props: Props) => {
	return (
		<div>
		<SectionTitle>Tilaaja, jolla allekirjoitusoikeus</SectionTitle>
		<Section>
		  <Container>
			<div className="info">
			  <input
				// TODO: procura list should be all rendered, not just first item. Not supported feature?
				value={props.customerProcuraData[0].firstName ? props.customerProcuraData[0].firstName : 'Tietoa ei saatavilla'}
				type="text"
				readOnly
			  />
			  <input
				value={props.customerProcuraData[0].emailAddress ? props.customerProcuraData[0].emailAddress : 'Tietoa ei saatavilla'}
				type="text"
				readOnly
			  />
			</div>
		  </Container>
		</Section>
	  </div>
	);
};
